import React from 'react'
import { BarChart3 } from 'lucide-react'

const CompanyAnalytics = () => (
  <div className="space-y-6">
    <div className="flex items-center">
      <BarChart3 className="w-6 h-6 text-primary-600 mr-2" />
      <h1 className="text-2xl font-bold text-secondary-900">Company Analytics</h1>
    </div>
    <div className="card p-6 text-secondary-600">Analytics placeholder</div>
  </div>
)

export default CompanyAnalytics


